import { Button } from '@/components/ui/shadcn/button'
import { Minus, Plus, Redo, Repeat, Undo } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/shadcn/tooltip'

interface Props {
  isOpen: boolean
  scale: number
  onZoomIn: () => void
  onZoomOut: () => void
  onResetScale: () => void
  onFitAll: () => void
  onUndo: () => void
  onRedo: () => void
  canUndo: boolean
  canRedo: boolean
}

export function WorkspaceEditorBottomBar({
  isOpen,
  scale,
  onZoomIn,
  onZoomOut,
  onResetScale,
  onFitAll,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
}: Props) {
  return (
    <div
      className={`absolute bottom-2 left-2 flex items-center gap-2 ${isOpen ? 'ml-64' : 'ml-0'} transition-all duration-300 ease-in-out`}>
      <TooltipProvider delayDuration={300}>
        <div className="border-border bg-card shadow-xs flex items-center rounded-full border">
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="secondary" size="icon-sm" onClick={onZoomIn} className="border-none">
                <Plus />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <span>Zoom in</span>
            </TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="secondary" size="sm" onClick={onResetScale} className="border-none">
                {Math.round(scale * 100)}%
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <span>Reset scale</span>
            </TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="secondary"
                size="icon-sm"
                onClick={onZoomOut}
                className="border-none">
                <Minus />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <span>Zoom out</span>
            </TooltipContent>
          </Tooltip>
        </div>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="secondary" size="icon-sm" onClick={onFitAll} className="border-border">
              <Repeat />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <span>Fit all containers</span>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="secondary"
              size="icon-sm"
              onClick={onUndo}
              disabled={!canUndo}
              className="border-border">
              <Undo />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <span>Undo</span>
          </TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="secondary"
              size="icon-sm"
              onClick={onRedo}
              disabled={!canRedo}
              className="border-border">
              <Redo />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <span>Redo</span>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}
